import isFreeSampleVariantUtil from 'modules/variant/utils/is-free-sample'
import isPaidSingleUseSampleVariantUtil from 'modules/variant/utils/is-paid-single-use-sample'
import { FREE_SAMPLE, SINGLE_USE_SAMPLE, DELUXE_SAMPLE } from 'modules/variant/constants'

const getSampleLabelVariantUtil = (variant) => {
  if (isFreeSampleVariantUtil(variant)) {
    return FREE_SAMPLE
  }

  if (isPaidSingleUseSampleVariantUtil(variant)) {
    return SINGLE_USE_SAMPLE
  }

  return DELUXE_SAMPLE
}

export default getSampleLabelVariantUtil
